// extracted by mini-css-extract-plugin
module.exports = {"grayButton":"Button_grayButton__GYTvj"};